// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ce7aaf5a","453":"2240f033","551":"6f038b82"}[chunkId] + ".chunk.js";
};